<template>

    <!-- <div class="w-100"> -->

        <!-- v-model="inputText" -->
        <Editor
            class="w-100"
            :editorStyle="editorStyle"
            :placeholder="placeholder"
            :pt="{
                root: {style: 'padding: 0px;'},
            }"
            @input="$emit('update:modelValue', $event.target.value)"
        >
            <!-- :modules="modules" -->
            <!-- @input="onTextChange" -->
            <template v-slot:toolbar>
                <span class="ql-formats">
                    <select class="ql-header"></select>
                    <select class="ql-font"></select>
                </span>

                <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                </span>

                <span class="ql-formats">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                </span>

                <span class="ql-formats">
                    <button class="ql-list" value="bullet" type="button"></button>
                    <button class="ql-list" value="ordered"></button>
                    <select class="ql-align"></select>
                </span>

                <span class="ql-formats">
                    <button class="ql-link"></button>
                    <!-- <button class="ql-image"></button> -->
                </span>

                <span class="ql-formats">
                    <button class="ql-clean"></button>
                </span>
            </template>
        </Editor>

        <!-- <div id="counter">0</div> -->

    <!-- </div> -->

</template>


<script>
import Editor from "primevue/editor";
// import Quill from "quill";

// import BlotFormatter from '@enzedonline/quill-blot-formatter2/dist/BlotFormatter';
// import QuillResizeImage from 'quill-resize-image';

// import { onMounted, ref } from 'vue';

// const Clipboard = Quill.import('modules/clipboard');
// const Counter = Quill.import('modules/counter');
// const Delta = Quill.import('delta');

// class PlainClipboard extends Clipboard {
//   convert(html = null) {
//     // if (typeof html === 'string') {
//     //   this.container.innerHTML = html;
//     // }
//     // let text = this.container.innerText;
//     // this.container.innerHTML = '';
//     return new Delta().insert(html);
//   }
// }

// function Counter(quill, options) {
//                 const container = document.querySelector('#counter');
//                 console.log(quill, options);

//                 // quill.on(Quill.events.TEXT_CHANGE, () => {
//                 //     const text = quill.getText();
//                 //     // There are a couple issues with counting words
//                 //     // this way but we'll fix these later
//                 //     container.innerText = text.split(/\s+/).length;
//                 // });
//             }

// class Counter1 {
//     constructor(quill, options) {
//         this.quill = quill;
//         this.options = options;

//         const container = document.querySelector(options.container);
//         quill.on(Quill.events.TEXT_CHANGE, () => {
//         const text = quill.getText();
//         if (options.unit === 'word') {
//             container.innerText = text.split(/\s+/).length + ' words';
//         } else {
//             container.innerText = text.length + ' characters';
//         }

//         });
//     }

//     calculate() {
//         const text = this.quill.getText();

//         return this.options.unit === 'word' ?
//         text.split(/\s+/).length :
//         text.length;
//     }
// }

// class Test {
//     constructor(quill, options) {
//         console.log(options);
//         this.quill = quill;
//         this.options = options;
//         this.container = document.querySelector(options.container);
//         quill.on(Quill.events.TEXT_CHANGE, this.update.bind(this));

//     }

//     calculate() {
//         const text = this.quill.getText();

//         console.log(text);


//         if (this.options.unit === 'word') {
//             const trimmed = text.trim();
//             // Splitting empty text returns a non-empty array
//             return trimmed.length > 0 ? trimmed.split(/\s+/).length : 0;
//         } else {
//             return text.length;
//         }
//     }

//     update() {
//         const length = this.calculate();
//         let label = this.options.unit;
//         if (length !== 1) {
//             label += 's';
//         }
//         this.container.innerText = `${length} ${label}`;
//     }
// }

export default {
    name: 'TextEditorC',
    props: {
        editorStyle: {
            type: String,
            default: 'height: 240px;',
        },
        placeholder: String,
        // modelValue: null,
    },
    components: {
        Editor,
    },
    // emits: ["update:modelValue"],
    setup() {
        // const modules = ref();
        // const inputText = ref('');

        // const onTextChange = () => {
        //     context.emit("update:modelValue", inputText.value);
        //     // if (inputText.value.length > 0) filterClear.value = true;
        //     // else filterClear.value = false;

        //     // context.emit("update:modelValue", event.target.value);
        //     // if (event.target.value.length > 0) filterClear.value = true;
        //     // else filterClear.value = false;
        // };

        // console.log(props.modelValue);


        // onMounted(() => {
        //     // // inputText.value = props.modelValue;
        //     // // Quill.register('modules/clipboard', PlainClipboard, true);
        //     // // Quill.register('modules/blotFormatter', BlotFormatter, true);
        //     // Quill.register('modules/test', Test);

        //     // // Quill.register('modules/resize', QuillResizeImage, true);
        //     // modules.value = {
        //     //     // blotFormatter: {},
        //     //     test: {
        //     //         container: '#counter',
        //     //         unit: 'word',
        //     //     },
        //     //     // clipboard: {},
        //     //     // resize: {},
        //     // };
        // });


        return {
            // modules,
            // inputText,
            // onTextChange,
        };
    },
}
</script>